import { Box, Stack, Typography } from "@mui/material";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import Button from "@/components/ui/Button";
import { ButtonStyleType } from "@/types/shared/uiComponents";
import { BORDER_RADIUS } from "@/constants/layout";

interface QuickUploadCTAProps {
  onClick: () => void;
}

export const QuickUploadCTA = ({ onClick }: QuickUploadCTAProps) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        borderRadius: BORDER_RADIUS.LARGE,
        border: "2px dashed",
        borderColor: "primary.main",
        bgcolor: "background.paper",
        p: 3,
        cursor: "pointer",
        transition: "all 0.2s ease",
        "&:hover": {
          bgcolor: "action.hover",
        },
      }}
    >
      <Stack direction={{ xs: "column", sm: "row" }} alignItems="center" justifyContent="space-between" spacing={2}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: BORDER_RADIUS.MEDIUM,
              bgcolor: "primary.main",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CloudUploadOutlinedIcon sx={{ color: "white", fontSize: 28 }} />
          </Box>
          <Box>
            <Typography variant="h4" color="primary.main">
              Quick Upload
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Drop documents to create claims, reimbursements, or policies
            </Typography>
          </Box>
        </Stack>
        <Button variant={ButtonStyleType.Contained} tabIndex={-1}>
          Get Started
        </Button>
      </Stack>
    </Box>
  );
};
